import React, { ReactNode } from 'react';

import { SvgIconNames } from '~/design-tokens/iconography/SvgIcons';

import { Separator } from '../DropdownMenu.styles';
import * as S from './DropdownGroup.styles';

export type DropdownEntry = {
  label: ReactNode;
  key: string;
  iconName?: SvgIconNames;
  disabled?: boolean;
  onClick?: (e?: Event | React.MouseEvent) => void;
};

export type DropdownGroupProps = {
  items: DropdownEntry[];
  className?: string;
};

export const DropdownGroup = ({ items, className }: DropdownGroupProps) => {
  const isMouseClickRef = React.useRef(false);

  return (
    <S.DropdownWrapper data-testid="dropdown-wrapper" className={className}>
      <S.DropdownGroup>
        {items.map(item => (
          <S.DropdownMenuItem
            key={item.key}
            onSelect={() => {
              // Only handle keyboard navigation - mouse clicks are handled by onClick
              if (!isMouseClickRef.current) {
                item?.onClick?.();
              }

              isMouseClickRef.current = false;
            }}
            disabled={item.disabled}
            data-testid={`dropdown-group-item-${item.key}`}
            data-key={item.key}
          >
            <S.DropdownItemButton
              $disabled={item.disabled}
              onClick={e => {
                // Handle mouse clicks with full MouseEvent
                isMouseClickRef.current = true;
                item?.onClick?.(e);
              }}
            >
              {item.iconName && (
                <S.DropdownIcon iconName={item.iconName} size={16} />
              )}
              <S.DropdownItemLabel>{item.label}</S.DropdownItemLabel>
            </S.DropdownItemButton>
          </S.DropdownMenuItem>
        ))}
      </S.DropdownGroup>
      <Separator />
    </S.DropdownWrapper>
  );
};

DropdownGroup.Styled = S;
